import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-basicdata_roadsectionmanage",
  "use": "icon-basicdata_roadsectionmanage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-basicdata_roadsectionmanage\"><defs><style type=\"text/css\"></style></defs><path d=\"M704 554.666667v298.666666h-128V426.666667h298.666667v128h-170.666667z m-554.666667-384h725.333334v128h-725.333334V170.666667z m298.666667 256v426.666666h-128v-298.666666h-170.666667v-128h298.666667z\" p-id=\"13504\" fill=\"#6a6d74\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol